module.exports = __webpack_public_path__ + "static/media/general.c8e597f1.jpg";